import DatetimeContainer from "../date/DatetimeContainer";
import React, { useEffect } from "react";
import Lottie from "react-lottie";
import RebateRate from "../../pages/components/RebateRate";
import CountDownTimer from "../timer/CountDownTimer";
import TableStatistic from "./TableStatistic";
import ColorItems from "./mix/ColorItems";
import { cards12, getColorNumbers, isDisabledODEO, pfType } from "../../constants/general";
import { lotto12CardUrl } from "../../utils/asset";
import { getCardVersion } from "../../utils/cached";
import LoadingGif from "../../utils/LoadingGif";
import { useLotto12 } from "../../store/lotto12/Lotto12Context";

export default () => {
    const lotto = useLotto12();
    const {
        t, oldResult, isStopped, isStartFlip,
        winUnderOver,
        winOddEven,
        winNumber,
        winColor,
        config: { lotto12Config },
        newResult,
        onBetting,
    } = lotto;
    const jackpot = oldResult?.jackpot;
    const isShow = oldResult?.numberCode === oldResult?.jackpotType;
    const platformType = pfType;


    const runFlipAnimation = lotto.runFlipAnimation;
    const clearFlipTimers = lotto.clearFlipTimers;


    useEffect(() => {
        isStartFlip && runFlipAnimation();
        return () => clearFlipTimers && clearFlipTimers();
    }, [isStartFlip, runFlipAnimation, clearFlipTimers]);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: require(`../../assets/images/lotto12/${platformType}.json`),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };


    return <div className="col no-padding-div none-select">
        <div className="row">

            {!isStopped ? <div className="col-6 no-padding-div lotto12-bg">
                <div className="lotto12-betting-animation mt-8-vw">
                    <Lottie options={defaultOptions}
                        isStopped={isStopped}
                        isPaused={false} />
                </div>
            </div> :
                <div className="col-6 no-padding-div lotto12-bg">
                    <div className="mt-8-vw">
                        <div className="col-12 lotto12-mt-vw">
                            <div className="pl-3 pr-3 pt-3">
                                <div className="pl-3 pr-3 row justify-content-center">
                                    {
                                        cards12.map((_, i) => {
                                            return <div key={i} className="flip-card card-size no-padding-div">
                                                <div className="flip-card-inner" id={`card-inner-${i}`}>
                                                    <div className="flip-card-front">
                                                        <img className="img-responsive"
                                                            src={require(`../../assets/images/lotto12/${platformType}.png`)}
                                                            alt="" />
                                                    </div>
                                                    <div className="flip-card-back">

                                                        <img id={`img-${i}`} className="img-responsive"
                                                            src={require(`../../assets/images/lotto12/${platformType}.png`)}
                                                            alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mb-4">
                            <div className="row pt-3 justify-content-center">
                                <div className="no-padding-div">
                                    <div className="flip-card-inner " id="card-inner-result">
                                        <div className="flip-card-front">
                                            <img className="img-responsive"
                                                src={require(`../../assets/images/lotto12/${platformType}.png`)}
                                                alt="" />
                                        </div>
                                        <div className="flip-card-back">
                                            {isShow &&
                                                <div className="jackpot-12-number">
                                                    {jackpot > 1 && <img
                                                        width={50}
                                                        height={50}
                                                        className="jp-animate"
                                                        src={require(`../../assets/images/jackpot/${jackpot}.png`)}
                                                        alt="" />}
                                                </div>}
                                            <img id="img-result" className="img-responsive"
                                                src={require(`../../assets/images/lotto12/${platformType}.png`)}
                                                alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            <div className="col-6 no-padding-div lotto12-betting">

                <div className="col row">
                    <div className="col-3 lotto12-countdown-number">
                        <CountDownTimer countClass="text-center f-32 " {...lotto} />
                    </div>
                    <div
                        className="col-9 header-div-title header-text fade-in padding-div-right lotto12-new-result">
                        <span className="text-white draw-code">
                            <LoadingGif width="30" height="30" />
                            {(newResult !== null && newResult.drawLabel) ? newResult.drawLabel : t("labels:upcoming_draw")}
                        </span>
                        <span className="text-white fade-in last-result-betting datetime"
                            id="timer-display"><DatetimeContainer /></span>
                    </div>
                </div>

                <div className="col-12 row">
                    <div className="col-6 div-body-white fade-in">
                        <div className="row">
                            {
                                lotto12Config.underOverOddEven.map((item, i) =>

                                    <div id={`card-${item.code}`}
                                        className={`col-6 no-padding-div pointer lotto6-box-bet lotto12-bet-pricing-card no-radius ${(item.code === winUnderOver || item.code === winOddEven) ? " color-animated" : ""}`}
                                        key={i}
                                        onClick={isDisabledODEO ? null : () => onBetting(item)}>
                                        <div className="slot-prefix-card">
                                            <div className={"lotto12-bet-" + item?.code}>
                                                <div
                                                    className="lotto12-bet-label">
                                                    <span>{t("labels:betPrefix." + item?.code)}</span></div>
                                                <RebateRate classRebate={`rebate-${item.type}`} rate={item.value} />
                                            </div>

                                        </div>
                                    </div>
                                )
                            }
                        </div>

                    </div>

                    <div className="col-6 div-body-white  fade-in">
                        <div className="row">
                            {
                                lotto12Config.colors.map((item, i) =>
                                    <div id={`card-${item.code}`}
                                        className={`col-4 no-padding-div lotto12-bet-pricing-card no-radius ${item.code === winColor ? "color-animated" : ""}`}
                                        key={i}
                                        onClick={() => onBetting(item)}>
                                        <div className="slot-prefix-card">
                                            <div className={"lotto12-bet-" + item?.code}>
                                                <div
                                                    className="lotto12-bet-label-color">{t("labels:betPrefix." + item?.code)}</div>
                                                <ColorItems values={getColorNumbers(item?.code)} />
                                                <RebateRate classRebate={`rebate-${item.type}`} rate={item.value} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="col-12 div-body-white fade-in">
                        <div className="row">
                            {
                                lotto12Config.numbers.map((item, i) =>
                                    <div id={`card-${item.code}`}
                                        className={`col-2 no-padding-div ${item.code === winNumber ? "color-animated" : ""}`}
                                        key={i}
                                        onClick={() => onBetting(item)}>
                                        <div>
                                            {(isShow && winNumber === item.code) &&
                                                <div className="jackpot-12-number">
                                                    {jackpot > 1 && <img id={item.code}
                                                        width={30}
                                                        className="jp-animate"
                                                        height={30}
                                                        src={require(`../../assets/images/jackpot/${jackpot}.png`)}
                                                        alt="" />}
                                                </div>}
                                            <img className="img-responsive"
                                                src={lotto12CardUrl(item?.code)}
                                                alt="" />
                                            {getCardVersion() === "v1" &&
                                                <RebateRate classRebate={`rebate-${item.type}`} rate={item.value} />}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* History drawing */}
        <TableStatistic />

    </div>;
}
